import React from 'react';
import { Loader2 } from 'lucide-react';
import { PractitionerProfile } from 'app/javascript/types';
import ProfileHeader from 'app/javascript/components/profile/ProfileHeader';
import Timeline from 'app/javascript/components/profile/Timeline';
import CheckInHeatmap from 'app/javascript/components/profile/CheckInHeatmap';
import HeatmapLegendTrigger from 'app/javascript/components/profile/HeatmapLegendTrigger';
import SectionHeading from 'app/javascript/components/ui/SectionHeading';

interface ProfileViewProps {
  profile: PractitionerProfile;
  isLoading?: boolean;
  slug?: string;
}

const ProfileView: React.FC<ProfileViewProps> = ({ profile, isLoading = false, slug }) => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="pointer-events-none fixed inset-x-0 top-0 h-[500px] bg-gradient-to-b from-card/80 to-transparent" />

      <div className="relative z-10 mx-auto max-w-4xl px-4 py-8">
        <ProfileHeader profile={profile} />

        {slug && profile.companies?.[0]?.slug && (
          <div className="mb-12">
            <SectionHeading
              title={
                <span className="inline-flex items-center gap-2">
                  Sua Frequência
                  <HeatmapLegendTrigger slug={slug} companySlug={profile.companies[0].slug} />
                </span>
              }
              className="mb-6"
            />
            <div className="mx-auto rounded-2xl border border-border/40 bg-card/40 p-5 backdrop-blur-sm">
              <CheckInHeatmap slug={slug} companySlug={profile.companies[0].slug} />
            </div>
          </div>
        )}

        <div className="mb-12">
          <SectionHeading title="Sua Jornada" className="mb-8" />

          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="size-7 animate-spin text-yellow-400" />
            </div>
          ) : (
            <Timeline promotions={profile.beltHistory} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileView;
